import { EXPRESS_API } from 'configs/api/expressApi';
import { ILandingPageDesignsResponse } from '../landingPageDesigns/useQueryLandingPageDesigns';
import { useQuery } from 'react-query';
import { landingPageDesignGroupsKeys } from './keys';
import { errorToast } from 'lib/components/toasts/error';

export interface ISingleGroupParams {
  start: number;
  limit: number;
  groupId: number;
}

interface ISingleGroupResponse {
  landingPageDesignGroupId: number;
  title: string;
  landingPageDesigns: ILandingPageDesignsResponse;
}

const getSingleGroup = async (params: ISingleGroupParams) => {
  return (
    await EXPRESS_API.get(
      `/superadmin/landing-page-design-groups/${params.groupId}`,
      {
        params: {
          start: params.start,
          limit: params.limit,
        },
      }
    )
  ).data as ISingleGroupResponse;
};

export const useQueryGetSingleGroup = (params: ISingleGroupParams) => {
  return useQuery(
    landingPageDesignGroupsKeys.single_group_landing_pages(params),
    () => getSingleGroup(params),
    {
      onError: () => {
        errorToast({
          title: `We're currently experiencing difficulties fetching this group.`,
        });
      },
    }
  );
};
